/* eslint-disable simple-import-sort/imports */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

/* Modules */
import { AppCommonModule } from '@common/app-common.module';
import { NavigationModule } from '@modules/navigation/navigation.module';

/* Components */
import * as groupOrderComponents from './components';

/* Containers */
import * as groupOrderContainers from './containers';

/* Guards */
import * as groupOrderGuards from './guards';

/* Services */
import * as groupOrderServices from './services';
import { QRCodeModule } from 'angularx-qrcode';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  imports: [CommonModule, RouterModule, ReactiveFormsModule, FormsModule, AppCommonModule, NavigationModule, QRCodeModule, PipesModule],
  providers: [...groupOrderServices.services, ...groupOrderGuards.guards],
  declarations: [...groupOrderContainers.containers, ...groupOrderComponents.components],
  exports: [...groupOrderContainers.containers, ...groupOrderComponents.components],
})
export class GroupOrderModule {}
